import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";

import { formatAgeRange } from "layouts/dutyEstimator/constants";

// Shared by the Section 3 depreciation table and the three Section 4 penalty tables — they
// differ only in which rate column they carry, so `rateKey` selects it.
export default function ageBandTableData({ bandList = [], rateKey, rateLabel, onEdit, onDelete }) {
  return {
    columns: [
      { Header: "Band", accessor: "label", width: "28%", align: "left" },
      { Header: "Vehicle Age", accessor: "age", width: "32%", align: "left" },
      { Header: rateLabel, accessor: "rate", align: "center" },
      { Header: "Status", accessor: "status", align: "center" },
      { Header: "Actions", accessor: "actions", align: "center" },
    ],

    rows: bandList.map((band) => ({
      label: (
        <MDTypography variant="button" fontWeight="medium">
          {band?.label}
        </MDTypography>
      ),
      age: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {formatAgeRange(band?.minAgeMonths, band?.maxAgeMonths)}
        </MDTypography>
      ),
      rate: (
        <MDTypography variant="button" fontWeight="bold">
          {Number(band?.[rateKey] ?? 0)}%
        </MDTypography>
      ),
      status: (
        <Chip
          size="small"
          label={band?.isActive === false ? "Inactive" : "Active"}
          sx={{
            backgroundColor: band?.isActive === false ? "#eeeeee" : "#e8f5e9",
            color: band?.isActive === false ? "#616161" : "#2e7d32",
            fontWeight: 600,
          }}
        />
      ),
      actions: (
        <MDBox display="flex" alignItems="center" justifyContent="center" gap={1}>
          <Button size="small" onClick={() => onEdit(band)}>
            Edit
          </Button>
          <Button
            size="small"
            variant="contained"
            onClick={() => onDelete(band?.id)}
            sx={{ backgroundColor: "#d32f2f", color: "#fff", "&:hover": { backgroundColor: "#9a0007" } }}
          >
            Delete
          </Button>
        </MDBox>
      ),
    })),
  };
}
